// @ts-nocheck
/* eslint-disable */
export const moreIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 16"><g fill="currentColor" clip-path="url(#a)"><path d="M8.251 5.037a1.185 1.185 0 1 1 0-2.37 1.185 1.185 0 0 1 0 2.37m0 4.148a1.185 1.185 0 1 1 0-2.37 1.185 1.185 0 0 1 0 2.37m0 4.148a1.185 1.185 0 1 1 0-2.37 1.185 1.185 0 0 1 0 2.37"/></g><defs><clipPath id="a"><path fill="#fff" d="M13.585 2.667H2.918v10.667h10.667z"/></clipPath></defs></svg>`,
    name: 'more' as const
};